import {
  FaCertificate,
  FaCoffee,
  FaCompactDisc,
  FaImage,
  FaKey,
  FaShoppingBag,
  FaTag,
  FaTshirt,
} from "react-icons/fa";
import { FiTrendingUp, FiMusic, FiMic, FiDisc, FiVideo } from "react-icons/fi";
import { GiHoodie, GiMonclerJacket } from "react-icons/gi";
import { PiBaseballCapBold } from "react-icons/pi";

export const capitalizeWords = (str) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const formatPrice = (price, eur = false) => {
  if (!price) return eur ? "0 €" : "0 RSD";

  if (eur) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
    }).format(price);
  } else {
    return new Intl.NumberFormat("sr-Latn-RS", {
      style: "currency",
      currency: "RSD",
      minimumFractionDigits: 0,
    }).format(price);
  }
};

export const formatNewsDetailsDate = (date) => {
  const today = new Date();
  const newsDate = new Date(date);
  const diffTime = newsDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Danas";
  if (diffDays === 1) return "Sutra";
  if (diffDays === -1) return "Juče";
  if (diffDays > 0 && diffDays <= 7) return `Za ${diffDays} dana`;
  if (diffDays < 0 && diffDays >= -7) return `Pre ${Math.abs(diffDays)} dana`;

  return newsDate.toLocaleDateString("sr-Latn-RS", {
    day: "numeric",
    month: "long",
    year:
      newsDate.getFullYear() !== today.getFullYear() ? "numeric" : undefined,
  });
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day} ${month} ${year}, ${hours}:${minutes}h`;
};

export const formatDatePeriod = (startDateString, endDateString) => {
  const startDate = new Date(startDateString);
  const endDate = new Date(endDateString);

  const startDay = startDate.getDate();
  const endDay = endDate.getDate();

  // mesec i godina uzimamo iz krajnjeg datuma (ionako su isti u tvom slučaju)
  const month = endDate.toLocaleString("en-GB", { month: "short" });
  const year = endDate.getFullYear();

  return `${startDay}-${endDay} ${month}, ${year}`;
};

export const formatDateNoHours = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();

  return `${day} ${month}, ${year}`;
};

export const getBadgeLabel = (product) => {
  if (product.salePrice && product.price) {
    const discount = Math.round(
      ((product.price - product.salePrice) / product.price) * 100
    );
    return `-${discount}%`;
  }
  if (product.isNew) return "Novo";
  if (product.isLimited) return "Limited";
  if (product.isBestSeller) return "Bestseller";
  return "";
};

export const getVariant = (product) => {
  if (product.salePrice && product.price) {
    return "discount";
  }
  if (product.isNew) return "novo";
  if (product.isLimited) return "limited";
  if (product.isBestSeller) return "bestseller";
  return "";
};

export const getNewsTypeLabel = (type) => {
  const typeMap = {
    concert: "Koncert",
    album: "Album",
    interview: "Intervju",
    video: "Video",
    award: "Nagrada",
  };
  return typeMap[type] || type;
};

export const getNewsTypeIcon = (type) => {
  const iconMap = {
    concert: FiMusic,
    album: FiDisc,
    interview: FiMic,
    video: FiVideo,
    award: FiTrendingUp,
  };
  return iconMap[type] || FiMusic;
};
export const newsTypes = [
  { id: 1, name: "Koncert", icon: FiMusic, value: "concert" },
  { id: 2, name: "Album", icon: FiDisc, value: "album" },
  { id: 3, name: "Intervju", icon: FiMic, value: "interview" },
  { id: 4, name: "Video", icon: FiVideo, value: "video" },
  { id: 5, name: "Nagrada", icon: FiTrendingUp, value: "award" },
];
export const formatNewsDate = (date) => {
  const today = new Date();

  // Ako je string (iz inputa), konvertuj u Date
  const d = typeof date === "string" ? new Date(date) : date;

  const diffTime = d - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Danas";
  if (diffDays === 1) return "Sutra";
  if (diffDays === -1) return "Juče";
  if (diffDays > 0 && diffDays <= 7) return `Za ${diffDays} dana`;
  if (diffDays < 0 && diffDays >= -7) return `Pre ${Math.abs(diffDays)} dana`;

  return d.toLocaleDateString("sr-Latn-RS", {
    day: "numeric",
    month: "short",
    year: d.getFullYear() !== today.getFullYear() ? "numeric" : undefined,
  });
};

export const categoryMapping = {
  majica: {
    icon: FaTshirt,
    name: "Majice",
  },
  duks: {
    icon: GiHoodie,
    name: "Duksevi",
  },
  "vinil & cd": {
    icon: FaCompactDisc,
    name: "Vinili & CD",
  },
  vinil: {
    icon: FaCompactDisc,
    name: "Vinili",
  },
  cd: {
    icon: FaCompactDisc,
    name: "CD",
  },
  jakna: {
    icon: GiMonclerJacket,
    name: "Jakne",
  },
  kačket: {
    icon: PiBaseballCapBold,
    name: "Kačketi",
  },
  nalepnica: {
    icon: FaTag,
    name: "Nalepnice",
  },
  poster: {
    icon: FaImage,
    name: "Posteri",
  },
  privezak: {
    icon: FaKey,
    name: "Privesci",
  },
  šolja: {
    icon: FaCoffee,
    name: "Šolje",
  },
  torba: {
    icon: FaShoppingBag,
    name: "Torbe",
  },
  značka: {
    icon: FaCertificate,
    name: "Značke",
  },
  aksesoari: {
    icon: FaShoppingBag,
    name: "Aksesoari",
  },
};

export const getProductSizeStocks = (product) => {
  const stocks = [];
  if (product.sizeS && product.stockSizeS > 0)
    stocks.push(`S: ${product.stockSizeS}`);
  if (product.sizeM && product.stockSizeM > 0)
    stocks.push(`M: ${product.stockSizeM}`);
  if (product.sizeL && product.stockSizeL > 0)
    stocks.push(`L: ${product.stockSizeL}`);
  if (product.sizeXL && product.stockSizeXL > 0)
    stocks.push(`XL: ${product.stockSizeXL}`);
  if (product.sizeXXL && product.stockSizeXXL > 0)
    stocks.push(`XXL: ${product.stockSizeXXL}`);
  if (product.size3XL && product.stockSize3XL > 0)
    stocks.push(`3XL: ${product.stockSize3XL}`);
  if (product.size4XL && product.stockSize4XL > 0)
    stocks.push(`4XL: ${product.stockSize4XL}`);
  if (product.size5XL && product.stockSize5XL > 0)
    stocks.push(`5XL: ${product.stockSize5XL}`);
  return stocks;
};

export const getProductSizeStocksWithAlerts = (product) => {
  const stocks = [];

  const sizeConfig = [
    {
      size: "S",
      hasSize: product.sizeS,
      stock: product.stockSizeS,
      alert: product.stockAlertS,
    },
    {
      size: "M",
      hasSize: product.sizeM,
      stock: product.stockSizeM,
      alert: product.stockAlertM,
    },
    {
      size: "L",
      hasSize: product.sizeL,
      stock: product.stockSizeL,
      alert: product.stockAlertL,
    },
    {
      size: "XL",
      hasSize: product.sizeXL,
      stock: product.stockSizeXL,
      alert: product.stockAlertXL,
    },
    {
      size: "XXL",
      hasSize: product.sizeXXL,
      stock: product.stockSizeXXL,
      alert: product.stockAlertXXL,
    },
    {
      size: "3XL",
      hasSize: product.size3XL,
      stock: product.stockSize3XL,
      alert: product.stockAlert3XL,
    },
    {
      size: "4XL",
      hasSize: product.size4XL,
      stock: product.stockSize4XL,
      alert: product.stockAlert4XL,
    },
    {
      size: "5XL",
      hasSize: product.size5XL,
      stock: product.stockSize5XL,
      alert: product.stockAlert5XL,
    },
  ];

  sizeConfig.forEach(({ size, hasSize, stock, alert }) => {
    if (hasSize && stock >= 0) {
      // Show all sizes that are enabled, even if stock is 0
      const alertThreshold = alert || 10; // Default alert threshold
      let alertLevel = "normal";

      if (stock < alertThreshold) {
        alertLevel = "critical"; // Red
      } else if (stock < alertThreshold * 2) {
        alertLevel = "warning"; // Orange
      }

      stocks.push({
        size,
        stock,
        alertThreshold,
        alertLevel,
        displayText: `${size}: ${stock}`,
      });
    }
  });

  return stocks;
};

export const parseStockFromString = (stockString) => {
  // Parsira string tipa "S: 15" i vraća { size: 'S', stock: 15 }
  const match = stockString.match(/^(.+?):\s*(\d+)$/);
  if (match) {
    return {
      size: match[1].trim(),
      stock: parseInt(match[2], 10),
    };
  }
  return { size: stockString, stock: 0 };
};
